/**
 * @author 3173
 * @description 直播列表
 * @Date 2020/9/28
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,utils_tool ,component_tool} from '../../../../tool'
import {Col, Row} from "antd";
let { WizContainer, WizReduxTemplate } = framework_tool;
let { checkStrLength,Session } = utils_tool;
let {  WizBrowserExport ,WizCard,WizRow,WizCol} = component_tool;


const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/live/liveList/LiveRecordList'||history.location.pathname ==='/live/liveList/liveStatisticsList/LiveRecordList') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('liveInfo', record)
      } else {
        record = Session.get('liveInfo') || 0
      }
    }
  } else {
    record = Session.get('liveInfo') || 0
  }

  if(record.state==0){
    let liveRecord=Session.get('liveRecord');
    if(liveRecord){
      record.liveType=liveRecord.liveType;
      record.state=liveRecord.state;
      record.name=liveRecord.name;
      record.startDate=liveRecord.startDate;
    }
  }
  if (record.liveType == 1){
    record.liveType = '视频直播';
  }else if (record.liveType == 2){
    record.liveType = '互动直播';
  }else if(record.liveType == 3){
    record.liveType = '点播';
  }else if(record.liveType == 4){
    record.liveType = '远程认证';
  }else if(record.liveType == 5){
    record.liveType = '直播课堂';
  }else if(record.liveType == 6){
    record.liveType = '远程评估';
  }else if(record.liveType == 7) {
    record.liveType = '企微会议';
  }else if(record.liveType == 8) {
    record.liveType = '企微直播';
  }
   if (record.state == 1){
    record.state = '草稿';
  }else if (record.state == 2){
    record.state = '预告中';
  }else if(record.state == 3){
    record.state = '直播中';
  }else if(record.state == 4){
    record.state = '已结束';
  }
  return record
}



class LiveRecordList extends WizContainer {

  componentName = 'liveRecordList';

  constructor(props) {
    super(props);
    this.state = {
    }
    this.initialValue = getParamRecord(props.history);
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleListData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 15
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          val['name'] = checkStrLength(val['name'], len);
        });
      }
      f(o['data']['records'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      // {
      //   headerName: '证件号码',
      //   field: 'idCard',
      //   width: 30,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '用户属性',
        field: 'userType',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center', wrapText: true  },
        },
      },
      {
        headerName: '账号状态',
        field: 'state',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '组织名称',
        field: 'orgName',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '经销商编码',
        field: 'orgCode',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: "任职状态",
        field: "jobState",
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: "进入时间",
        field: "startTime",
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: "退出时间",
        field: "endTime",
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: "累计观看时长(分钟)",
        field: "durationMinute",
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: "累计进入次数",
        field: "countNumber",
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(d => {
        if (d.userType == 0){
          d.userType = '培训平台用户';
        }else if (d.userType == 3){
          d.userType = 'OEM部门用户';
        }else if (d.userType == 4){
          d.userType = '经销商用户';
        }else if (d.userType == 5){
          d.userType = '服务商用户';
        }

        if (d.state == 1){
          d.state = '激活';
        }else {
          d.state = '禁用';
        }

        if (d.jobState == 1){
          d.jobState = '在职';
        }else{
          d.jobState = '离职';
        }
      });

      WizBrowserExport({
        title: '参训记录',
        sheetName: '参训记录',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '参训记录.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }

  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        list: this._handleListData,
        export: this._handleFile,
        syncLiveRecord: this._handleCMD,
      },
      liveId : this.initialValue.id
    })
    return(
      <>
      <WizCard title={'直播信息'}>
        <Row style={{ marginTop: 10 }}>
          <Col span={12} push={2}>
            <span className="ant-table-column-title" style={{color: "rgba(0, 0, 0, 0.85)",fontWeight: 500}}>直播名称:</span>
            <span className="ant-table-row-cell-break-word"> {this.initialValue.name}</span>
          </Col>
          <Col span={12} push={2}>
            <span className="ant-table-column-title" style={{color: "rgba(0, 0, 0, 0.85)",fontWeight: 500}}>直播状态:</span>
            <span className="ant-table-row-cell-break-word"> {this.initialValue.state}</span>
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col span={12} push={2}>
            <span className="ant-table-column-title" style={{color: "rgba(0, 0, 0, 0.85)",fontWeight: 500}}>直播类型:</span>
            <span className="ant-table-row-cell-break-word"> {this.initialValue.liveType}</span>
          </Col>
          <Col span={12} push={2}>
            <span className="ant-table-column-title" style={{color: "rgba(0, 0, 0, 0.85)",fontWeight: 500}}>开播时间:</span>
            <span className="ant-table-row-cell-break-word"> {this.initialValue.startDate}</span>
          </Col>
        </Row>
      </WizCard>
      <WizCard title={'参训记录'}>
        <WizReduxTemplate {..._reduxTemplateCofig}  />
      </WizCard>

      </>
    );

  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(LiveRecordList);
